import React from "react";

export const RejectedIcon = ({ size = "22", color = "#FF3B3B" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 23"
      fill="none"
    >
      <circle cx="11.077" cy="11.3831" r="10" fill={color} stroke="white" strokeWidth="1.53846" />
      <path
        d="M14.4102 8.07812L7.74023 14.7481M7.74023 8.07812L14.4102 14.7481"
        stroke="white"
        strokeWidth="1.15385"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
